import CustomApplicationState from "@sunSource/Store/CustomApplicationState";

export const getOnePageCheckoutCustomNotesState = (state: CustomApplicationState) => {
    return state?.sunSourceState?.OnePageCheckoutCustomNotes;
};
